"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeDatePickerStyling = function (_a) {
    var _b;
    var isValid = _a.isValid, isError = _a.isError;
    var theme = (0, react_1.useTheme)();
    return {
        datePickerContainer: (0, react_1.css)(__assign(__assign({ height: 60, backgroundColor: theme.mvf.palette.background.answerBackgroundColor, boxSizing: 'border-box', border: 'solid', boxShadow: '0px 2px 5px rgba(33, 33, 33, 0.1)', borderRadius: theme.mvf.border.radius, borderWidth: theme.mvf.border.width.thin, borderColor: theme.mvf.palette.component.answerUnselectedColor, '& .MuiTextField-root, .MuiInputBase-root': {
                width: '100%',
                height: '100%',
            }, '& .MuiButtonBase-root.MuiIconButton-root': __assign(__assign({ marginLeft: -10, padding: 12, color: theme.mvf.palette.text.primaryTextColor }, (isValid && {
                color: theme.mvf.palette.component.answerSelectedColor,
            })), (isError && {
                color: theme.mvf.palette.status.error,
            })), '@media (hover: hover)': {
                '&:hover': {
                    boxShadow: theme.mvf.boxShadow.timid,
                    borderColor: theme.mvf.palette.component.answerSelectedColor,
                    '& .MuiButtonBase-root.MuiIconButton-root': {
                        color: theme.mvf.palette.component.answerSelectedColor,
                    },
                },
            }, '& fieldset': {
                border: 0,
            }, input: __assign((_b = { fontWeight: theme.mvf.typography.weight.thick, fontSize: theme.mvf.fontSize.mini }, _b[theme.breakpoints.up('mobileMedium')] = {
                fontSize: theme.mvf.fontSize.small,
            }, _b['&::placeholder'] = {
                fontWeight: theme.mvf.typography.weight.medium,
                color: theme.mvf.palette.status.disabled,
                opacity: 1,
            }, _b), (isError && {
                color: theme.mvf.palette.status.error,
            })) }, (isValid && {
            color: theme.mvf.palette.component.answerSelectedColor,
            boxShadow: theme.mvf.boxShadow.timid,
            borderColor: theme.mvf.palette.component.answerSelectedColor,
        })), (isError && {
            color: theme.mvf.palette.status.error,
            boxShadow: theme.mvf.boxShadow.error,
            borderColor: theme.mvf.palette.status.error,
            '& input::placeholder': {
                color: theme.mvf.palette.status.error,
            },
        }))),
        inputAdornmentEnd: (0, react_1.css)({
            position: 'absolute',
            right: theme.mvf.spacing.medium,
            '& .MuiSvgIcon-root': __assign(__assign({ fill: theme.mvf.palette.component.answerSelectedColor }, (isError && {
                fill: theme.mvf.palette.status.error,
            })), { fontSize: theme.mvf.fontSize.huge }),
        }),
        globalStyles: (0, react_1.css)({
            '& .MuiDayCalendar-root .MuiPickersDay-today': {
                color: theme.mvf.palette.component.answerSelectedColor,
            },
            '& .MuiDayCalendar-root .MuiPickersDay-today:not(.Mui-selected)': {
                border: 0,
            },
            '& .MuiDayCalendar-root .MuiPickersDay-root': {
                fontSize: theme.mvf.fontSize.small,
            },
            '& .MuiDayCalendar-root .MuiPickersDay-root.Mui-selected': {
                backgroundColor: theme.mvf.palette.component.answerSelectedColor,
                color: 'rgb(255, 255, 255)',
                '&:hover,:focus': {
                    backgroundColor: theme.mvf.palette.component.answerSelectedColor,
                },
            },
        }),
    };
};
exports.default = makeDatePickerStyling;
//# sourceMappingURL=makeDatePickerStyling.js.map